import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 font-heading text-xl text-background-50 mb-4 whitespace-nowrap">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-book-read-line text-xl"></i>
              </span>
              {t('site.name')}
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-md">
              {t('site.description')}
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-background-700 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-background-700 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-background-700 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('nav.category')}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/japanese" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">日系漫画</Link></li>
              <li><Link to="/category/doujinshi" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">同人志</Link></li>
              <li><Link to="/category/original" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">原创本子</Link></li>
              <li><Link to="/category/romance" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">恋爱题材</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">奇幻冒险</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">{t('nav.about')}</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">{t('footer.privacy')}</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">{t('footer.terms')}</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">{t('footer.dmca')}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {t('footer.copyright')}. {t('footer.rights')}.
          </p>
          <p className="text-xs text-background-600">
            本网站所有内容均经正版授权，未经许可禁止转载
          </p>
        </div>
      </div>
    </footer>
  );
}